import { render } from "./AdvancedConfig.vue?vue&type=template&id=6404b90a&scoped=true"
import script from "./AdvancedConfig.vue?vue&type=script&lang=js"
export * from "./AdvancedConfig.vue?vue&type=script&lang=js"

import "./AdvancedConfig.vue?vue&type=style&index=0&id=6404b90a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6404b90a"]])

export default __exports__